export enum FormSubmissionStepStatus {
  draft = 1,
  pendingApproval = 2,
  pendingFormSection = 3,
  pendingApprovalAndFormSection = 4,
  pendingFormCompletion = 5,
  pendingPayment = 6,
  completed = 7,
  approved = 8,
  rejected = 9
}